import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FadeIn } from './ui/FadeIn';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  q: '¿Es legal hacer esto yo mismo?',
  a: 'Sí, la ley FCRA te otorga el derecho explícito de disputar cualquier información en tu reporte. No necesitas una licencia ni un abogado para exigir que los burós cumplan la ley.'
}, {
  q: '¿Tengo que pagar las deudas para que se borren?',
  a: 'No siempre. Si la información es inexacta, está incompleta o no puede ser verificada por el acreedor original, la ley exige que debe borrarse del reporte aunque exista el saldo.'
}, {
  q: '¿Cuánto tiempo tarda?',
  a: 'Los burós tienen 30 días para responder por ley tras recibir tu disputa. La mayoría de las limpiezas profundas toman entre 2 y 3 rondas (aproximadamente 90 días en total).'
}, {
  q: '¿Funciona para deudas de tarjetas de crédito?',
  a: 'Absolutamente, es el uso más común de nuestras plantillas. Funciona para pagos tarde, cuentas cerradas (charge-offs) y colecciones derivadas de tarjetas de crédito.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 bg-navy text-white" data-id="element-25">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-26">
        <FadeIn data-id="element-27">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-28">
            Preguntas Frecuentes
          </h2>
        </FadeIn>

        <div className="space-y-4" data-id="element-29">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <FadeIn key={index} delay={0.1 * index} data-id="element-30">
                <div className={`border rounded-lg overflow-hidden transition-colors duration-300 ${isOpen ? 'border-gold bg-navy-light' : 'border-navy-light bg-navy'}`} data-id="element-31">
                  <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-32">
                    <span className={`font-serif text-lg ${isOpen ? 'text-gold' : 'text-white'}`} data-id="element-33">
                      {faq.q}
                    </span>
                    <ChevronDownIcon className={`w-5 h-5 flex-shrink-0 transition-transform duration-300 ${isOpen ? 'transform rotate-180 text-gold' : 'text-gray-400'}`} data-id="element-34" />
                  </button>
                  <AnimatePresence data-id="element-35">
                    {isOpen && <motion.div initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.3,
                  ease: 'easeInOut'
                }} data-id="element-36">
                        <div className="px-6 pb-5 text-gray-300 font-sans leading-relaxed" data-id="element-37">
                          {faq.a}
                        </div>
                      </motion.div>}
                  </AnimatePresence>
                </div>
              </FadeIn>;
        })}
        </div>
      </div>
    </section>;
}